import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../componenets/FormikReusable/FormikControl";

export const FormContainer = () => {
  const initialvalues = {
    email: "",
    description: "",
    selectStandard: "",
    RadioOption: "",
    checkboxOption: [],
    birthdate: null,
  };
  const validationSchema = Yup.object({
    email: Yup.string().required().email(),
    description: Yup.string().required(),
    selectStandard: Yup.string().required(),
    RadioOption: Yup.string().required(),
    checkboxOption: Yup.array().required(),
    birthdate: Yup.date().required().nullable(),
  });
  const onSubmit = (values) => {
    console.log("form data ", values);
  };
  const options = [
    { key: "select a standard ", value: "" },
    { key: "std 1 ", value: "1" },
    { key: "std 2 ", value: "2" },
    { key: "std 3 ", value: "3" },
    { key: "std 4 ", value: "4" },
  ];
  const optionsRadio = [
    { key: "option1", value: "r1" },
    { key: "option2", value: "r2" },
    { key: "option3", value: "r3" },
  ];
  const optionsCheck = [
    { key: "option1", value: "c1" },
    { key: "option2", value: "c2" },
    { key: "option3", value: "c3" },
  ];
  return (
    <Formik
      initialValues={initialvalues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      validateOnMount
    >
      {(formik) => {
        return (
          <div
            className="container "
            style={{ marginTop: "12px", width: "500px" }}
          >
            <Form>
              <FormikControl
                control="input"
                type="email"
                label="Email"
                name="email"
              />
              <FormikControl
                control="textarea"
                label="Description"
                name="description"
              />
              <FormikControl
                control="select"
                label="Select Standard"
                name="selectStandard"
                options={options}
              />
              <FormikControl
                control="radio"
                label="Select Options"
                name="RadioOption"
                options={optionsRadio}
              />
              <br />
              <FormikControl
                control="checkbox"
                label="Select checkbox Options"
                name="checkboxOption"
                options={optionsCheck}
              />
              <br />
              <FormikControl
                control="date"
                label="BirthDate"
                name="birthdate"
              />

              <button
                type="submit"
                style={{ margin: "10px" }}
                disabled={!formik.isValid}
              >
                Submit
              </button>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};
